import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../models/report.model';
import { PhotoService } from '../../services/photo.service';

@Component({
  selector: 'app-notre-organisme',
  templateUrl: './notre-organisme.component.html',
  styleUrls: ['./notre-organisme.component.scss'],
})
export class NotreOrganismeComponent implements OnChanges {
  @Input() organisme!: Report.Organisme;
  @Input() reportId!: string;
  @Input() isLoading = false;
  organismePhoto!: string | undefined;
  organismeLogo!: string | undefined;

  organismeInternal!: Report.Organisme;
  organismePhotoInternal!: string | undefined;
  organismeLogoInternal!: string | undefined;

  @Output() organismeChanged = new EventEmitter<Report.Organisme>();
  @Output() organismeEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  constructor(private readonly photoService: PhotoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.changes(changes);
  }

  private async changes(changes: SimpleChanges) {
    if (changes['organisme']) {
      this.organismeInternal = structuredClone(
        changes['organisme'].currentValue,
      );
      this.organismePhoto = await this.photoService.getOrganismePhoto(
        this.reportId,
      );

      this.organismeLogo = await this.photoService.getOrganismeLogo(
        this.reportId,
      );

      this.organismeLogoInternal = this.organismeLogo;
      this.organismePhotoInternal = this.organismePhoto;
    }
  }

  /**
   * Lorsque la section change on la met à jour
   * @param organisme
   */
  onOrganismeChanged(organisme: Report.Organisme): void {
    this.organismeInternal = structuredClone(organisme);
  }

  /**
   * Lorsque la photo change on la met à jour
   * @param photo
   */
  onChangePhoto(photo: string) {
    this.organismePhotoInternal = photo;
  }

  /**
   * Lorsque le logo change on le met à jour
   * @param logo
   */
  onChangeLogo(logo: string) {
    this.organismeLogoInternal = logo;
  }

  /**
   * Lorsqu'on sauvegarde on envoi la section avec les photos
   */
  onSaveSection(): void {
    this.organismeInternal.photo = this.organismePhotoInternal;
    this.organismeInternal.logo = this.organismeLogoInternal;
    this.organismeChanged.emit(this.organismeInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.organismeEnabled.emit(isEnabled);
  }

  /**
   * Lorsque on clique sur la croix rouge d'un logo il devient vide
   */
  onClearLogo(): void {
    this.organismeLogoInternal = undefined;
  }

  /**
   * Lorsque on clique sur la croix rouge d'une photo elle devient vide
   */
  onClearPhoto(): void {
    this.organismePhotoInternal = undefined;
  }

  /**
   * Lorsque on clique sur annuler on remet comme on la recu du rapport
   */
  onCancled() {
    this.organismeInternal = structuredClone(this.organisme);
    this.organismeLogoInternal = this.organismeLogo;
    this.organismePhotoInternal = this.organismePhoto;
  }
}
